<template>
  <!-- eslint-disable-next-line max-len -->
  <!-- yarn run vue-cli-service test:unit --silent tests/unit/components/presentations/contents/CorrectOrderContent.spec.js -->
  <div class="w-full h-full horizontal layout center">
    <div
      class="correct-order-container"
      v-if="isContentVisible"
      :class="[`has-${numberOfSlideOptionsWithId}-column`]"
    >
      <div
        class="correct-order-result-container"
      >
        <div
          class="correct-order-result"
          v-show="showLineCorrectOrder"
        >
          <div
            :key="slideOption.id"
            v-for="(slideOption, index) in canvasSlideOptions"
            class="correct-order-result-box-container animate__animated animate__fadeIn"
            :style="{'width': getWidthMasonry}"
          >
            <div
              class="correct-order-result-box"
              :style="{'background-color': slideOption.color}"
            >
              {{ index + 1 }}
            </div>
            <div
              class="relative"
              v-if="index !== canvasSlideOptions.length - 1"
            >
              <div class="absolute left-6">
                <div class="correct-order-result__divider"></div>
                <div class="correct-order-result__arrow"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        v-masonry
        horizontal-order="true"
        :transition-duration="`${masonryTransitionDuration}ms`"
        item-selector=".correct-order-item"
        class="mb-5"
      >
        <div
          v-masonry-tile
          v-for="(slideOption, index) in canvasSlideOptions"
          :key="slideOption.id"
          :style="{'width': getWidthMasonry}"
          :class="`correct-order-item correct-order-item-${slideOption.id}`"
        >
          <div
            class="statement-content"
            :style="{ 'box-shadow': getSlideOptionBoxShadow(slideOption),
                      'background-color': getSlideOptionBackgroundColor()}"
          >
            <div v-if="isDefaultContent" class="statement-content__default-text">
              Statement {{ index + 1 }}
            </div>
            <div
              v-else
              class="statement-content__main-text"
              :class="{'__empty-title': !slideOption.title }"
            >
              {{ slideOption.title }}
            </div>
          </div>
        </div>
      </div>

      <div class="match-answer horizontal layout center center-justified">
        <Answer v-if="isNumberOfParticipantCorrectVisible" />
      </div>
    </div>

    <CanvasQuestionImage v-if="!isContentVisible" />
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Answer from '@/components-v2/presentation-editor/match-pairs/Answer.vue'
import CanvasQuestionImage from '@/components-v2/presentation-editor/middle/CanvasQuestionImage.vue'
import utils from '@/util'
import EventBus from '@/eventBus'
import QuizStatuses from '@/constant/QuizStatuses'
import Constant from '@/constant'
import randomAhaColorUtil from '@/utils/randomAhaColorUtil'
import SlideApi from '@/api/slide'
import Socket from '@/socket'

const { colors } = Constant

export default {
  components: {
    Answer,
    CanvasQuestionImage,
  },
  data() {
    return {
      masonryTransitionDuration: Constant.MASONRY_TRANSITION_DURATION,
      QuizStatuses,
      canvasSlideOptions: [],
      showLineCorrectOrder: false,
      showNumberParticipantCorrect: false,
    }
  },
  computed: {
    ...mapGetters(['isBackstage', 'isPresenting']),
    ...mapState({
      slideActive: (state) => state.slideActive,
      slideOptions: (state) => state.slideActive.SlideOptions,
      isSharingView: (state) => state.sharePresentation,
      presentation: (state) => state.presentation,
    }),
    isContentVisible() {
      const presenting = this.isPresenting
      const { slideActive } = this.$store.state
      const noQuestionImg = !slideActive.showQuestionImage || !slideActive.image

      if ((!presenting && noQuestionImg) || (slideActive.type === 'pickAnswer' && presenting && !this.$store.state.sharePresentation) || (slideActive.type === 'pickAnswer' && this.$store.state.sharePresentation && noQuestionImg)) {
        return true
      }
      return false
    },
    isDefaultContent() {
      return this.slideOptions.every((option) => !option.id)
    },
    isQuizResultScene() {
      return this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN
    },
    isLobbyScene() {
      return this.slideActive.quizStatus === QuizStatuses.LOBBY_SCREEN
    },
    hasBackgroundImage() {
      return this.slideActive.backgroundImage
    },
    getWidthMasonry() {
      let size = 192.5

      if (this.canvasSlideOptions.length >= 6) {
        size = 174
      }
      if ((this.isPresenting || this.isBackstage)
        && !this.isSharingView) {
        size -= 4.9
      }
      return `${size}px`
    },
    numberOfSlideOptionsWithId() {
      if (this.isDefaultContent) {
        return this.slideOptions.length || 5
      }
      return this.slideOptions.filter((option) => option.id).length || 5
    },
    isNumberOfParticipantCorrectVisible() {
      return ((this.isQuizResultScene || this.isLobbyScene) && this.showNumberParticipantCorrect) ||
        (!this.isPresenting && !this.isBackstage)
    },
  },
  watch: {
    'slideActive.quizStatus': function resultUpdated() {
      this.handleShowResultScene()
    },
    'slideActive.showCorrectOption': function watchShowCorrectOption(showCorrectOption) {
      if (showCorrectOption) {
        this.handleShowResultScene()
      }
    },
    '$store.state.presentation.fontFamily': function watchFontFamily() {
      this.redrawMasonry()
    },
    showLineCorrectOrder: function watchShowLineCorrectOrder(isShow) {
      if (isShow) {
        setTimeout(() => { // timeout a bit for the transition effect
          utils.allowPDFRender()
        }, 500)
      }
    },
  },
  mounted() {
    if (this.isSharingView) {
      this.handleShowResultScene()
    } else {
      setTimeout(() => {
        this.handleShowCorrectOrderContent()
      }, 10)
    }

    EventBus.$on('redraw-masonry-correct-order', () => {
      this.redrawMasonry()
    })
    EventBus.$on('correct-order-changes', (action) => {
      if (this.isDefaultContent) return
      this.handleShowCorrectOrderContent(action)
    })
    EventBus.$on('update-correct-order-canvas-content', () => {
      this.canvasSlideOptions = this.filterCanvasSlideOptions()
    })
  },
  destroyed() {
    EventBus.$off('redraw-masonry-correct-order')
    EventBus.$off('correct-order-changes')
    EventBus.$off('update-correct-order-canvas-content')
  },
  methods: {
    ...mapActions(['updateSlideActiveAction']),

    getSlideOptionBoxShadow(item) {
      return `0 0 0 1.5px ${item.color}`
    },

    getSlideOptionBackgroundColor() {
      const color = utils.hexToRgba(this.$store.state.slideActive.baseColour)
      return utils.changeRgbaColor(color, 0.6)
    },

    redrawMasonry() {
      const DELAY = 500
      utils.disallowPDFRender()
      setTimeout(() => {
        this.$redrawVueMasonry()
      }, DELAY)
    },

    _setDefaultContentColor(optionsArray) {
      if (!optionsArray) return
      const defaultColors = colors.slice(0, 5) // default 5 options
      optionsArray = optionsArray.forEach((opt, index) => {
        opt.color = defaultColors[index]
      })
    },

    hasOptionsColors(optionsArray) {
      if (!optionsArray) return false
      return optionsArray.every((opt) => opt.id && opt.color)
    },

    filterCanvasSlideOptions() {
      if (this.isDefaultContent) {
        if (!this.hasOptionsColors(this.slideOptions)) {
          this._setDefaultContentColor(this.slideOptions)
        }
        return this.slideOptions
      }
      if (!this.hasOptionsColors(this.slideOptions)) {
        this._setOptionsColor()
      }
      return this.filterSlideOptions()
    },

    filterSlideOptions() {
      return this.slideOptions
        .filter((option) => option.id)
        .map((option) => {
          return {
            ...option,
            title: option.title && option.title.length > 50 ? `${option.title.slice(0, 50)}…` : option.title,
          }
        })
    },

    handleShowCorrectOrderContent(action) {
      this.canvasSlideOptions = this.filterCanvasSlideOptions()
      if (action === 'editTitle') return
      if (this.isDefaultContent) {
        if (!this.hasOptionsColors(this.canvasSlideOptions)) {
          this._setDefaultContentColor(this.canvasSlideOptions)
        }
        this.redrawMasonry()
        return
      }
      this.handleShuffleSlideOptions(action)
    },

    _setOptionsColor() {
      // shuffle max 7 options if no slide's randomColours
      if (!this.slideActive.randomColours.length) {
        this._updateSlideActiveRandomColours()
      }
      this.slideOptions.forEach((opt, optIndex) => {
        opt.color = this.slideActive.randomColours[optIndex]
      })
      this.updateSlideActiveAction({
        SlideOptions: this.slideOptions,
      })
    },

    async _updateSlideActiveRandomColours() {
      try {
        const payload = {
          randomColours: randomAhaColorUtil
            .getArrayRandomAhaColor(Constant.MAX_CORRECT_ORDER_OPTIONS), // 7
        }
        this.updateSlideActiveAction(payload)
        await SlideApi.updateSlideById(this.slideActive.id, {
          ...payload,
          socketId: Socket.getSocketId(),
          accessCode: this.presentation.uniqueAccessCode,
        })
      } catch (error) {
        // catch error
      }
    },

    _getOptions() {
      return this.slideOptions.filter((option) => option.id)
    },

    handleShuffleSlideOptions(action) {
      if (!this.hasOptionsColors(this.slideOptions) || action === 'rearrangeOptions') {
        this._setOptionsColor()
      }
      this.canvasSlideOptions = utils.shuffleArrayWithSeed(
        this._getOptions(),
        this.slideActive.id,
      )
      this.redrawMasonry()
    },

    handleShowResultScene() {
      if (this.presentation.manualRevealCorrectAnswers && !this.slideActive.showCorrectOption) {
        return
      }
      if (this.slideActive.quizStatus === QuizStatuses.RESULT_SCREEN || this.isSharingView) {
        this.updateSlideActiveAction({
          showQuestionImage: false,
        })
        this.canvasSlideOptions = this.filterCanvasSlideOptions()
        setTimeout(() => {
          this.redrawMasonry()
          this.showNumberParticipantCorrect = true
          setTimeout(() => {
            this.showLineCorrectOrder = true
          }, 1500)
        }, 500)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.correct-order-container {
  @apply w-full my-0 mx-auto;
  padding: 0 30px;
  .match-answer {
    min-height: 60px;
  }
  &.has-1-column {
    width: 20%;
  }
  &.has-2-column {
    width: 35%;
  }
  &.has-3-column {
    width: 50%;
  }
  &.has-4-column {
    width: 65%;
  }
  &.has-5-column {
    width: 80%;
  }
  &.has-6-column {
    width: 87%;
    .correct-order-result-container .correct-order-result__divider {
      width: 5.5rem;
    }
  }
  &.has-7-column {
    .correct-order-result-container .correct-order-result__divider {
      width: 5rem;
    }
  }
}
.correct-order-item {
  padding: 14px 11px 7px 11px;
  .statement-content {
    border-radius: 4px;
    transition: all 0.25s;
    &:hover {
      transform: scale(1.05);
    }
    .statement-content__default-text {
      padding: 2.5rem 0;
      text-align: center;
    }
    .statement-content__main-text {
      @apply p-4 break-words;
      &.__empty-title {
        padding: 29.5px;
      }
    }
  }
}

.correct-order-result-container {
  @apply relative pt-4 pb-16;
  .correct-order-result {
    @apply w-full flex absolute;
    top: 30px;
    .correct-order-result-box-container {
      @apply flex items-center justify-center;
    }
    .correct-order-result__divider {
      @apply h-0.5 bg-secondary-20 mr-1;
      width: 6.5rem;
    }
    .correct-order-result__arrow {
      border-top: 9px solid transparent;
      border-bottom: 9px solid transparent;
      border-left: 9px solid #D3D7E1;
      @apply absolute right-0 -top-2;
    }
    .correct-order-result-box {
      @apply rounded-full text-base-0;
      @apply flex items-center justify-center;
      width: 32px;
      height: 32px;
    }
  }
}
</style>
